
import React, { useEffect, useState } from 'react'
import { TextSM } from '../../../../Components/Text/NormalText';
import NuDate from '../../../../Components/Utils/NuDate';
import { Link, useParams } from 'react-router-dom';
import { NewPill } from '../../../../Components/Utils/StatusPills';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import ViewEquipmentsClient from '../../../Web/Client Management/Clients/EquipmentView';
import { Modal } from 'antd';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import * as yup from "yup";
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import EditIcon from '../../../../Components/Icons/Edit';
import UseGetDataSearchlist from '../../../../Components/Hooks/useFetchDataByListing';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuInputWithError } from '../../../../Components/Utils/Input';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UsecatEquipDD from '../../../../Components/Hooks/UseCatEquipDD';
import EquipViewMore from './EquipViewMore';


function DetailsEquipCard({ item,getData,clientViewId,data,isLoading }) {
      const { contractsViewId, id } = useParams();
      const [showEditDialog, setShowEditDialog] = useState(false);
      const [editEquipmentId, setEditEquipmentId] = useState(null);
    
        const [isViewModalOpen, setIsViewModalOpen] = useState(false); // View modal state
    const { value: unit, getData: refunit } = useFetchMataData(
    "/dropdown/dropdown-details/",
    "unit_equipments"
  );

    const [searchequipment, setSearchequipment] = useState("");
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [categories, setCategories] = useState([]);
    const [searcheCat, setSearcheCat] = useState("");
  
     const [viewModalData, setViewModalData] = useState(null);
    
                      const openViewModal = (data) => {
                        setViewModalData(data);
                        setIsViewModalOpen(true);
                      };
  const { editFormData } = useEditFormData();
const { data: equipmentOptions, setData: setEquipmentOptions } = UsecatEquipDD(
    "/equipments/drop-down",
    searchequipment,
    selectedCategoryId
  );
    return (

        <>
        <div className="w-full border bg-white rounded-lg shadow-xl mt-4 mb-2">
   
        <div className="flex justify-between bg-[#ECEBF3]  rounded-t-lg items-center px-4 py-2">
          <p className=" w-auto h-auto    flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
            {item?.idNumber || "#"}
          </p>
          <div className=" flex items-center gap-3">
            <div className="flex items-center gap-2 overflow-hidden">
              {item?.status &&
               
                  <NewPill text={item?.status} />
              
                }
            </div>
           <EquipViewMore id={item?.id}         getData={getData}
  data={item} />
          </div>
        </div>
        <div className=" px-2 pb-2">
          <div className=" px-2 w-full h-8 mt-2 truncate  overflow-hidden">
            <Link
              className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
              to={`/invoice/invoice-outgoing/view/${item?.invoiceOutId}`}
              state={{ data: item }}
            >
              {item?.itemName || "-"}
            </Link>
          </div>
          <div
            className="w-full flex justify-between items-center flex-wrap gap-2 mb-2 rounded-md p-2"
            style={{ border: "1px solid #C0C0C0" }}
          >
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Location : " || "-"} />
                <div className=" text-xs ">{item?.location || "-"}</div>
              </div>
            </div>
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Paymt. Due Date : " || "-"} />
                <div className=" text-xs ">
                                  {(item?.paymentDueDate != "None" && (
                                    <NuDate value={item?.paymentDueDate} format="DD-MMM-YY" />
                                  )) ||
                                    "-"}
                                </div>
              </div>
            </div> */}

            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Unit : " || "-"} />
                <div className=" text-xs ">{item?.unit || "-"}</div>
              </div>
            </div>
             <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Type : " || "-"} />
                <div className=" text-xs ">{item?.type || "-"}</div>
              </div>
            </div>
             <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"QR Code : " || "-"} />
                <div className=" text-xs ">{item?.qrCode || "-"}</div>
              </div>
            </div>
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"qrCode : " || "-"} />
                <div className=" text-xs text-right w-[48%] "> <NuAmount  value={(item.amount)}/></div>
              </div>
            </div> */}
            
  
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"InspectionDate : " || "-"} />
                <div className=" text-xs ">
                  {(item?.inspectionDate != "None" && (
                    <NuDate value={item?.inspectionDate} format="DD-MMM-YY" />
                  )) ||
                    "-"}
                </div>
              </div>
            </div> */}
  
           
          </div>
        </div>
      </div>

{isViewModalOpen && (       
    <Modal
    open={isViewModalOpen}
    onCancel={()=>setIsViewModalOpen(false)}
    title={"View Equipment"}
    width="50%"
    centered
       className="my-modal"
 
    footer={[]}
  >
    <ViewEquipmentsClient data={viewModalData} open={isViewModalOpen} onCancel={() => setIsViewModalOpen(false)} />
</Modal>
  )}


</>
    );

    
  }

export default DetailsEquipCard
